import React, {useMemo} from 'react';
import {Popup, ToolbarItem} from "devextreme-react/popup";

export interface IMessageBoxProps {
    title: string,
    message: string,
    buttonType: "OuiNon" | "Ok" | "OkAnnuler",
    onConfirme: () => void,
    onAnnuler: () => void,
    isOpen: boolean,
}

const MessageBox = ({message, buttonType, title, onConfirme, onAnnuler, isOpen}: IMessageBoxProps) => {
    const okOuiBtnOptions = useMemo(() => ({
        text: buttonType === "OuiNon" ? 'Oui' : "Ok",
        onClick: onConfirme
    }), [buttonType, onConfirme]);
    const annulerBtnOptions = useMemo(() => ({
        text: buttonType === "OuiNon" ? 'Non' : "Annuler",
        onClick: onAnnuler,
        visible: (buttonType === "OuiNon" || buttonType === "OkAnnuler")
    }), [buttonType, onAnnuler]);

    return (
        <Popup title={title} dragEnabled={true} position={"center"} visible={isOpen} width={"500px"} height={"auto"}>
            <div style={{width: "100%", textAlign: "center"}} dangerouslySetInnerHTML={{__html: message.replace("\n", "</br>")}}/>
            <ToolbarItem options={okOuiBtnOptions}
                         widget="dxButton"
                         toolbar="bottom"
                         location="center"/>
            <ToolbarItem options={annulerBtnOptions}
                         widget="dxButton"
                         toolbar="bottom"
                         location="center"/>
        </Popup>
    );
};

export default MessageBox;